<template>
  <div class="mb-3 mt-3">
    <b-container>
      <b-row>
        <b-col v-if="!loaded && !showError" class="col-12 col-md-12 mb-3">
          <b-card>
            <div class="d-flex justify-content-center mb-3 mt-3">
              <b-spinner></b-spinner>
            </div>
          </b-card>
        </b-col>
        <b-col v-if="showError" class="col-12 col-md-12 mb-3">
          <b-card>
            <p class="text-center">{{ $t('colony.form.not_found') }}</p>
          </b-card>
        </b-col>
      </b-row>
      <h1 class="text-primary font-weight-bold text-center mb-5">{{ data.title || "\u00a0" }}</h1>
      <b-row>
        <b-col v-if="loaded && !showError" class="col-12 col-md-12 mb-3">
            <b-alert show variant="danger" class="text-center">{{ $t('unite_colonies_or_remove_queen2.text') }}</b-alert>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col class="col-12 col-md-6 mb-3">
          <b-link class="bg-transparent text-primary border-primary border form-control text-center" :title="$t('unite_colonies_or_remove_queen2.cancel')" :to="'/colony/' + colony + '/' + data.apiary">
            {{ $t('unite_colonies_or_remove_queen2.cancel') }}
          </b-link>
        </b-col>
        <b-col class="col-12 col-md-6 ">
          <b-link class="bg-primary text-light form-control text-center" :title="$t('unite_colonies_or_remove_queen2.remove_queen')" @click.prevent="doDelete">
            {{ $t('unite_colonies_or_remove_queen2.remove_queen') }}
          </b-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-12">
          <b-link class="bg-primary text-light form-control text-center" :title="$t('unite_colonies_or_remove_queen2.unite_colonies')" @click="checkNetworkColonyUnite">
            {{ $t('unite_colonies_or_remove_queen2.unite_colonies') }}
          </b-link>
        </b-col>
      </b-row>
      <b-modal :id="'offLineColonyQueenDelete'" centered hide-header-close @ok="hideModal" class="network-modal">
        <template slot="modal-title">
          {{ $t('offLineModal.title') }}
        </template>
        {{ $t('offLineModal.text') }}
        <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
          <b-button size="lg" class="mt-3" @click="ok()">
            {{ $t('offLineModal.ok') }}
          </b-button>
        </template>
      </b-modal>
      <b-modal :id="'colonyQueenDeleteConfirm'" centered hide-header-close @ok="hideModal" class="network-modal">
        {{ $t('queen.modal.confirm_delete_text') }}
        <template slot="modal-footer" class="offline-modal-footer">
          <b-button size="lg" class="mt-3" @click="onDeleteConfirm()">
            {{ $t('queen.modal.ok') }}
          </b-button>
        </template>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'UniteColoniesOrRemoveQueen2',
  props: ['queen', 'colony'],
  data () {
    return {
      showError: false,
      loaded: false,
      data: {
        title: null
      }
    }
  },
  methods: {
    showOffLineModal () {
      this.$bvModal.show('offLineColonyQueenDelete')
    },
    hideModal () {
      this.$bvModal.hide('offLineColonyQueenDelete')
    },
    checkNetworkColonyUnite () {
      if (navigator.onLine) {
        this.$router.push('/unite-colonies/' + this.colony)
      } else {
        this.showOffLineModal()
      }
    },
    showDeleteConfirmationModal () {
      this.$bvModal.show('colonyQueenDeleteConfirm')
    },
    hideDeleteConfirmationModal () {
      this.$bvModal.hide('colonyQueenDeleteConfirm')
    },
    onDeleteConfirm () {
      this.loaded = true
      this.hideDeleteConfirmationModal()
      this.$router.push('/unite-colonies-or-remove-queen3/' + this.colony)
    },
    async doDelete () {
      if (navigator.onLine) {
        this.loaded = false
        const token = await this.$api.user.getToken()
        const result = this.$api.queens.deleteItem({ id: this.queen, token })
        this.showDeleteConfirmationModal()
        return result
      } else {
        this.showOffLineModal()
      }
    }
  },
  async mounted () {
    if (this.colony) {
      try {
        this.data = await this.$api.colonies.getOne(this.colony)
        if (this.data) {
          this.loaded = true
        } else {
          this.showError = 'not found'
        }
      } catch (e) {
        this.showError = 'not found'
      }
    }
  }
}
</script>

<style scoped>
  .container {
    max-width: 500px;
    font-family: "Roboto Condensed", sans-serif;
  }
</style>
